export default "__VITE_ASSET__BrwZveyd__"